import { getClassNameForField, religiousDuesFields as fields } from '../../constants'
import { useTranslationService } from '../../util/TranslationContext'
import { EditableFormPage } from '../components/EditableFormPage'

const ReligiousDuesCreate = () => {
    const { translateFields } = useTranslationService()
    const religiousDuesFields = translateFields(fields, 'religious_dues')

    return (
        <>
            <EditableFormPage
                title='Create Religious Dues'
                submitUrl='admin/religious-dues'
                fields={religiousDuesFields}
                classNameForField={getClassNameForField}
                loadingMessage='Loading...'
                errorMessage='Failed to fetch data.'
                create={true}
                navigateLink='/admin/auth/religious-dues'
            />
        </>
    )
}

export default ReligiousDuesCreate
